const TuitionTypesOne = () => {
  return (
    <section className='tuition-types py-120 position-relative z-1 mash-bg-main mash-main-style-two mash-bg-main-two mash-two-style-two overflow-hidden'>
      <div className='container'>
        <div className='section-heading text-center'>
          <div className='flex-align d-inline-flex gap-8 mb-16'>
            <span className='text-main-600 text-2xl d-flex'>
              <i className='ph-bold ph-book-open' />
            </span>
            <h5 className='text-main-600 mb-0'>Tuition Types</h5>
          </div>
          <h2 className='mb-24'>
            Find the Best Tuition Type which suits you most
          </h2>
          <p className=''>
            Where you can explore the range of services and benefits available
            to you. Whether you're a student looking...
          </p>
        </div>
        <div className='row gy-4'>
          <div className='col-xl-3 col-lg-4 col-sm-6 col-xs-6 wow bounceIn'>
            <div className='tuition-types-item animation-item h-100 text-center px-16 py-60 rounded-12 bg-white box-shadow-md transition-2 item-hover hover-bg-main-600'>
              <span className='w-96 h-96 flex-center d-inline-flex bg-main-25 text-main-600 text-40 rounded-circle item-hover__bg'>
                <span className='animate__wobble'>
                  <i className='ph ph-house-line' />
                </span>
              </span>
              <h4 className='display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2'>
                Home Tutoring
              </h4>
            </div>
          </div>
          <div className='col-xl-3 col-lg-4 col-sm-6 col-xs-6 wow bounceIn'>
            <div className='tuition-types-item animation-item h-100 text-center px-16 py-60 rounded-12 bg-white box-shadow-md transition-2 item-hover hover-bg-main-600'>
              <span className='w-96 h-96 flex-center d-inline-flex bg-main-two-25 text-main-two-600 text-40 rounded-circle item-hover__bg'>
                <span className='animate__wobble'>
                  <i className='ph ph-wifi-high' />
                </span>
              </span>
              <h4 className='display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2'>
                Online Tutoring
              </h4>
            </div>
          </div>
          <div className='col-xl-3 col-lg-4 col-sm-6 col-xs-6 wow bounceIn'>
            <div className='tuition-types-item animation-item h-100 text-center px-16 py-60 rounded-12 bg-white box-shadow-md transition-2 item-hover hover-bg-main-600'>
              <span className='w-96 h-96 flex-center d-inline-flex bg-main-three-25 text-main-three-600 text-40 rounded-circle item-hover__bg'>
                <span className='animate__wobble'>
                  <i className='ph ph-users' />
                </span>
              </span>
              <h4 className='display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2'>
                Group Tutoring
              </h4>
            </div>
          </div>
          <div className='col-xl-3 col-lg-4 col-sm-6 col-xs-6 wow bounceIn'>
            <div className='tuition-types-item animation-item h-100 text-center px-16 py-60 rounded-12 bg-white box-shadow-md transition-2 item-hover hover-bg-main-600'>
              <span className='w-96 h-96 flex-center d-inline-flex bg-main-two-25 text-main-two-600 text-40 rounded-circle item-hover__bg'>
                <span className='animate__wobble'>
                  <i className='ph ph-users-three' />
                </span>
              </span>
              <h4 className='display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2'>
                Package Tutoring
              </h4>
            </div>
          </div>
          <div className='col-xl-3 col-lg-4 col-sm-6 col-xs-6 wow bounceIn'>
            <div className='tuition-types-item animation-item h-100 text-center px-16 py-60 rounded-12 bg-white box-shadow-md transition-2 item-hover hover-bg-main-600'>
              <span className='w-96 h-96 flex-center d-inline-flex bg-main-two-25 text-main-two-600 text-40 rounded-circle item-hover__bg'>
                <span className='animate__wobble'>
                  <i className='ph ph-buildings' />
                </span>
              </span>
              <h4 className='display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2'>
                School Tutoring
              </h4>
            </div>
          </div>
          <div className='col-xl-3 col-lg-4 col-sm-6 col-xs-6 wow bounceIn'>
            <div className='tuition-types-item animation-item h-100 text-center px-16 py-60 rounded-12 bg-white box-shadow-md transition-2 item-hover hover-bg-main-600'>
              <span className='w-96 h-96 flex-center d-inline-flex bg-main-three-25 text-main-three-600 text-40 rounded-circle item-hover__bg'>
                <span className='animate__wobble'>
                  <i className='ph ph-building-office' />
                </span>
              </span>
              <h4 className='display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2'>
                College Tutoring
              </h4>
            </div>
          </div>
          <div className='col-xl-3 col-lg-4 col-sm-6 col-xs-6 wow bounceIn'>
            <div className='tuition-types-item animation-item h-100 text-center px-16 py-60 rounded-12 bg-white box-shadow-md transition-2 item-hover hover-bg-main-600'>
              <span className='w-96 h-96 flex-center d-inline-flex bg-main-two-25 text-main-two-600 text-40 rounded-circle item-hover__bg'>
                <span className='animate__wobble'>
                  <i className='ph ph-graduation-cap' />
                </span>
              </span>
              <h4 className='display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2'>
                University Tutoring
              </h4>
            </div>
          </div>
          <div className='col-xl-3 col-lg-4 col-sm-6 col-xs-6 wow bounceIn'>
            <div className='tuition-types-item animation-item h-100 text-center px-16 py-60 rounded-12 bg-white box-shadow-md transition-2 item-hover hover-bg-main-600'>
              <span className='w-96 h-96 flex-center d-inline-flex bg-main-25 text-main-600 text-40 rounded-circle item-hover__bg'>
                <span className='animate__wobble'>
                  <i className='ph ph-music-notes' />
                </span>
              </span>
              <h4 className='display-four mb-0 mt-32 text-neutral-700 item-hover__text transition-2'>
                Music Tutoring
              </h4>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TuitionTypesOne;
